import { useRagnar } from '@mentimeter/ragnar-react';
import { FullSizeContainer } from '@mentimeter/visualizations-react/utils/full-size-container';
import { GuessTheNumber } from '@mentimeter/visualizations-react/visualizations/guess-the-number';
import type { ScoreData } from './numerical-scale/NumericalScale';

interface GuessTheNumberVisualizationProps {
  responseRangeMin: number;
  responseRangeMax: number;
  responseRangeScale: number;
  correctAnswerRange: {
    min: number;
    max: number;
  };
  results: ScoreData;
  shouldShowCorrect: boolean;
}

export const GuessTheNumberVisualization = ({
  responseRangeMin,
  responseRangeMax,
  responseRangeScale,
  correctAnswerRange,
  results,
  shouldShowCorrect,
}: GuessTheNumberVisualizationProps) => {
  const {
    theme: {
      colors: { bg },
      visualizationColors,
      fonts: { body },
    },
  } = useRagnar();

  return (
    <FullSizeContainer>
      {(width, height) => (
        <GuessTheNumber
          width={width}
          height={height}
          rangeMax={responseRangeMax}
          rangeMin={responseRangeMin}
          data={results}
          correctAnswer={correctAnswerRange.min}
          shouldShowCorrectAnswer={shouldShowCorrect}
          fontFamily={body}
          responseRangeScale={responseRangeScale}
          colors={visualizationColors.fillColors as [string, ...string[]]}
          textColor={visualizationColors.textColor}
          backgroundColor={bg}
        />
      )}
    </FullSizeContainer>
  );
};
